import styled from 'styled-components'
import { mobileS, mobileM, mobileL } from '../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const JobsDetailsWrapper = styled.div`
  padding-bottom: 180px !important;
  position: relative;

  .cardContainer {
    position: absolute;
    width: 100vw;
    height: 100vh;
    will-change: transform;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 200px !important;
  }

  .card {
    position: absolute;
    margin-bottom: 200px !important;
    width: 100%;
    will-change: transform;
    border: none;
    max-width: 736px;
    margin: auto;
    left: 0;
    right: 0;

    @media (max-height: 670px) {
      margin-bottom: 0 !important;

      .cardContainer {
        height: 100%;
      }
    }
  }
`
